import React from 'react';
import {HibuFacetErrorCode} from './facet.types';
import {useTranslation} from 'react-i18next';

type FacetErrorMessageProps = {
    errorCode: HibuFacetErrorCode | undefined;
};

export const FacetErrorMessage = React.memo(({errorCode}: FacetErrorMessageProps) => {
    const {t} = useTranslation();

    switch (errorCode) {
        case HibuFacetErrorCode.OVERFLOW_FACET_COUNT:
            return <div className={'facet-error'}>
                <div className={'facet-error-text'}>
                    {t('facets.errors.overflow')}
                </div>
                ;
            </div>;
        case HibuFacetErrorCode.COUNT_NOT_AVAILABLE:
            return <div className={'facet-error'}>
                <div className={'facet-error-text'}>
                    {t('facets.errors.count-not-available')}
                </div>
            </div>;
        default:
            return <></>;
    }
});
